<template>
  <div class="internal-parts-listing">
    <v-layout class="p-2 pr-0 border-bottom-light-grey min-height-57px">
      <v-flex md="8" class="d-flex font-level-3-bold my-auto">
        <span class="form-title font-size-20 font-weight-700">

           <v-text-field
          v-if="serialized > 0"
          v-model.trim="search"
          v-on:click:clear="search = null,getProductInventory(type_id)"
          clearable
          dense
          filled
          flat
          label="Search Serial Number"
          hide-details
          solo
          :loading="pageLoading"
          :disabled="pageLoading"
          color="cyan"
          @keydown.enter="getProductInventory(type_id)"
          @keydown.tab="getProductInventory(type_id)"
          style="max-width: 250px"
          class="mr-2"
        ></v-text-field>
        </span>
      </v-flex>
      <v-flex md="4" class="font-level-3-bold my-auto d-flex">
        <v-spacer></v-spacer>
       
      </v-flex>
    </v-layout>
    <template v-if="serialized > 0">
      <InventorySerialTable
        :inventoryData="inventoryData"
        :loading="pageLoading"
        :inbondDate="inbondDate"
        :inbondDoc="inbondDoc"
         :key="`product-serialization-${inventoryKey}`"
      />
    </template>
    <template v-else>
      <NonInventorySerialTable
        :inventoryData="inventoryData"
        :loading="pageLoading"
        :inbondDate="inbondDate"
        :inbondDoc="inbondDoc"
        :key="`product-non-serialization-${inventoryKey}`"
      />
    </template>

    <ListingFooter
      :dataLoading="pageLoading"
      :currentPage="current_page"
      :totalPages="total_pages"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="total_rows"
      removePage
    ></ListingFooter>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
/* import showBarcode from "@/view/components/showBarcode.vue"; */
// import moment from "moment-timezone";
/* import Barcode from "@/view/pages/partials/Barcode.vue"; */
/* import TableActivity from "@/view/pages/partials/Table-Activity.vue"; */
import InventorySerialTable from "@/view/pages/part/detail/Serialized-Inventory.vue";
import NonInventorySerialTable from "@/view/pages/part/detail/Non-Serialized-Inventory.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      pageLoading: false,
      inventoryData: new Array(),
      search: null,
      per_page: 15,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      inventoryKey: Number(new Date()),
    };
  },
  components: {
    ListingFooter,
   /*  showBarcode, */
    /* Barcode, */
   /*  TableActivity, */
    InventorySerialTable,
    NonInventorySerialTable,
  },
  props: {
    type: {
      required: true,
      type: String,
      default: "",
    },
    type_id: {
      required: true,
      type: Number,
      default: 0,
    },
    serialized: {
      type: Number,
      default: 0,
    },
    inbondDate: {
      type: String,
      default: null,
    },
    inbondDoc: {
      type: String,
      default: null,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getProductInventory(type_id);
      }
    },
  },
  methods: {
   
    getProductInventory(productId) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(QUERY, {
          url: `all-serial-number/${this.type}/${productId}`,
          data: {
            //type: _this.type,
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.search,
          },
        })
        .then((data) => {
          this.inventoryData = data.data.rows;
          _this.offset = data.data.offset;
          _this.total_pages = Math.ceil(
            data.data.total_rows / data.data.per_page
          );
          _this.current_page = data.data.current_page;
          _this.total_rows = data.data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getProductInventory(type_id);
    }

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getProductInventory(_this.type_id);
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.inventoryData) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.inventoryData ? this.inventoryData.length : 0);
    },
  },
};
</script>
